module.exports = __webpack_public_path__ + "static/antd-table-basic-5e42e6abb6051d590483e29652248e0a.png";